import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Menu, Icon } from "semantic-ui-react";
import { logout } from "services/auth";
import { getPages } from "store/selectors";

function AppBarTablet(props) {
  const { currentPageKey, onAppBarPageClick, t } = props;
  const pages = useSelector(getPages);
  return (
    <Menu pointing className="app-bar" borderless>
      {pages.map((page) => (
        <Menu.Item
          data-test={page.key}
          key={page.key}
          as={Link}
          to={page.path}
          exact={page && page.exact && page.exact.toString()}
          active={page.key === currentPageKey}
          onClick={onAppBarPageClick}
        >
          {t(page.tKey)}
        </Menu.Item>
      ))}
      <Menu.Menu position="right">
        <Menu.Item name="logout" onClick={logout}>
          <Icon name="lock" />
          {t("logout")}
        </Menu.Item>
      </Menu.Menu>
    </Menu>
  );
}

export default AppBarTablet;
